export default __webpack_public_path__ + "static/media/awaiting7F.e2794363.svg";